import {Component, Input, NgModule, OnInit, ViewEncapsulation} from '@angular/core';
import {SubmissionSearchUserInfoObject} from '../../search-object';
import {Subscription} from 'rxjs';
import {SubmissionHistoryService} from '../../../../shared/services/submission-history.service';
import { BrowserModule } from '@angular/platform-browser';
import { NgxChartsModule } from '@swimlane/ngx-charts';

import { colorScheme } from './kpi-color-scheme';

@Component({
  selector: 'kpi-pie-chart',
  templateUrl: './kpi-pie-chart.component.html',
  styleUrls: ['./kpi-pie-chart.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class KpiPieChartComponent implements OnInit {

    @Input() userInfo: any;
    @Input() data: any;
    @Input() graphTitle: any;

    // options
    colorScheme: any[];
    view: any[] = [600, 300];
    legend = true;
    legendTitle = 'Gene Family';
    showLabels = true;
    animations = true;

    constructor(private submissionHistoryService: SubmissionHistoryService) {
        Object.assign(this, { colorScheme })
    }

    ngOnInit() {
    }

    public getKpiInfo() {

    }

    onSelect(data): void {
        console.log('Item clicked', JSON.parse(JSON.stringify(data)));
    }

    onActivate(data): void {
        console.log('Activate', JSON.parse(JSON.stringify(data)));
    }

    onDeactivate(data): void {
        console.log('Deactivate', JSON.parse(JSON.stringify(data)));
    }

}
